import React from 'react';
import { connect } from 'react-redux';
import { hashHistory  } from 'react-router';
import { resourceApi } from '../utils/fetchUtil';
import Paper from 'material-ui/Paper';
import Header from '../Components/Header/HeaderSmall';
import Spinner from '../Components/Spinner';
import StarOutline from 'material-ui/svg-icons/toggle/star-border';
import Star from 'material-ui/svg-icons/toggle/star';
import Sad from 'material-ui/svg-icons/social/sentiment-dissatisfied';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import TabStrip  from '../Components/TabStrip';
import Avatar from 'material-ui/Avatar';
import { amber500 } from 'material-ui/styles/colors';
import { red500 } from 'material-ui/styles/colors';
import styles from './../styles/shake.css';


const isApple  = /iPhone|iPad|iPod/i.test(navigator.userAgent);

const isAndroid  = /Android/i.test(navigator.userAgent);

class RateApp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            happy: false,
            sad: false, 
            fetching: false,
            update: null, 
            comments: "",
            rating: 0,
            starColor: amber500,
        };
    }

    componentDidMount() {
        // this.loadContent();
    }

    sendFeedback = (rating, comments) => {
        var self = this;

        let config = {
            method: 'post',
            url: `member/feedback`,
            data: {
                MemberFeedbackID: 0,
                Rating: rating,
                Comment: comments,
                ClientUserID: 0
            }
        };

        resourceApi(config) 
        .then(function (response) {
            self.setState({ submitted: true, fetching: false });
        });
    }

    submitFeedback = () => {
        if(this.state.rating > 0){
            this.setState({fetching: true}, ()=> { 
                return this.sendFeedback(this.state.rating, this.state.comments)
            }
        );

        }
        else{
            this.setState({starColor:red500})
            this.setState({starClass:'shake'})            
        }
    }

    resetStarClass = () => {
        this.setState({starClass:''})
    }

    loadContent() {
    
        // We only load content for androids, who need the package name in the URL to find the app. 
        var self = this;
        this.setState({isFetching: true});

        let config = {
            method: 'get',
            url: `application/updates`
        };

        resourceApi(config) 
        .then(function (response) {
            self.setState({ update: response.data, isFetching: false}); //, isApple: isApple, isAndroid, isAndroid });
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    handleFeedbackChange = (e, v) => {
        this.setState({ comments: v});
    }

    handleRatingChange = (rating) => {
        this.setState({ rating: rating, starColor:amber500});
        this.renderStars();
    }

    renderStars = () => {
        var rating = this.state.rating;
        var controls = [];
        var col = [1,2,3,4,5];
        col.map((item) => {
            if((rating > 0) && (item <= rating)){
                controls.push(<span><Star key={item} color={amber500} style={{height:30, width:30}} onClick={() => this.handleRatingChange(item)} /></span>);
            }            
            else{
                controls.push(<span><StarOutline className={'strOutline'} key={item} color={this.state.starColor} style={{height:30, width:30}} onClick={() => this.handleRatingChange(item)}  /></span>);
            }
        });
        return controls;
    }

    render() {
        return (
            
            <div>
                <div>
                        <Header title={"Rate Your Experience"}  />
                        <div className="container trueno" style={{marginTop: 20}}>
                            <Paper>
                                <div className="container truenoLight" style={{textAlign: 'center'}}>

                                    {this.state.fetching && (
                                        <Spinner />
                                    )}

                                    {!this.state.fetching && (
                                        <div>
                                             {this.state.submitted && (
                                                <div>
                                                    <br />
                                                    <h4>We appreciate your feedback.</h4>
                                                    <br />
                                                    <br />
                                                    <RaisedButton default={true} label="Return to the app" onClick={() => hashHistory.goBack()} />
                                                </div>
                                            )}
                                            
                                            {!this.state.submitted && (
                                                <div>
                                                    <div>
                                                        <h4>Enjoying this app?</h4>
                                                        <br />
                                                        <p>We’d love to hear your feedback!</p>
                                                        <br />
                                                    </div>
                                                    <div className="container">
                                                        <div style={{width:270, margin: '0 auto'}}>
                                                            <div className={this.state.starClass} onAnimationEnd={this.resetStarClass}>
                                                            {this.renderStars()}
                                                            </div>
                                                        <br />
                                                        <br />
                                                            <p>Provide a comment below if you'd like to leave additional feedback.</p>
                                                            <TextField value={this.state.comments} onChange={this.handleFeedbackChange} fullWidth={true} multiLine={true} />
                                                            <br />
                                                            <br />
                                                            <RaisedButton primary={true} label="Submit Feedback" onClick={this.submitFeedback} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <br />
                                    <br />
                                </div>
                            </Paper>
                        </div>
                    </div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <TabStrip activeTab={0} />
            </div>
        );
  }
};

//export default MyBenefits;

const mapDispatchToProps = (dispatch) => {
  return {
   
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RateApp)



// WEBPACK FOOTER //
// ./src/Pages/RateApp.js